import React, { useContext } from 'react'
import { DataContext } from '../store/GlobalState'

function ShowSuperAdminModal() {
    const { state, dispatch } = useContext(DataContext)

    const { auth, admin_ipm } = state
    return (
        <div className="modal-dialog easypm-modal-dialog modal-lg">
      <div className="modal-content easypm-modal-content">
        <div className="modal-header easypm-modal-header">
          <h5
            className="modal-title easypm-modal-title"
            id="ShowingFamilyModal"
          >
            Detail Admin
          </h5>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body easypm-modal-body">
          <div className="add-family-form-container">
            <div className="crud-form">
              <div className="row crud-row">
                <div className="col-md-6 crud-col-item">
                  <div className="form-group crud-form-group">
                    <strong htmlFor="numero_contrat">Prénom & Nom: </strong>

                    <span className="crud-form-control">
                      {admin_ipm?.prenom + ' ' + admin_ipm?.nom}
                    </span>
                  </div>
                </div>
                <div className="col-md-6 crud-col-item">
                  <div className="form-group crud-form-group">
                    <strong htmlFor="name">Email : </strong>
                    <span className="crud-form-control">
                      {admin_ipm?.email}
                    </span>
                  </div>
                </div>
                <div className="col-md-6 crud-col-item">
                  <div className="form-group crud-form-group">
                    <strong htmlFor="ninea">Téléphone: </strong>
                    <span className="crud-form-control">
                      {admin_ipm?.telephone}
                    </span>
                  </div>
                </div>
                <div className="col-md-6 crud-col-item">
                  <div className="form-group crud-form-group">
                    <strong htmlFor="email">Adresse : </strong>
                    <span className="crud-form-control">
                      {admin_ipm?.adresse}
                    </span>
                  </div>
                </div>

                <div
                  className="col-md-6 offset-md-6 crud-form-action-btn-container"
                  style={{ justifyContent: 'flex-end' }}
                >
                  <button
                    className="btn btn-danger cancelleb-btn"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    Retour
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    )
}

export default ShowSuperAdminModal
